import React from "react";
import { CheckIcon } from "../icons";

interface ValidatedInputProps {
  label: string;
  name: string;
  type?: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  required?: boolean;
  validation?: (value: string) => boolean;
  className?: string;
}

const ValidatedInput: React.FC<ValidatedInputProps> = ({
  label,
  name,
  type = "text",
  placeholder,
  value,
  onChange,
  onBlur,
  required = false,
  validation,
  className = "",
}) => {
  const isValid = validation ? validation(value) : value && value.trim();

  return (
    <div className={`space-y-2 ${className}`}>
      <label htmlFor={name} className="form-label">
        {label} {required && <span className="text-error-500">*</span>}
      </label>
      <div className="relative">
        <input
          type={type}
          name={name}
          id={name}
          className={`form-input ${isValid ? "form-input-valid" : ""}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          required={required}
        />
        {isValid && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-4 text-success-500">
            <CheckIcon />
          </div>
        )}
      </div>
    </div>
  );
};

export default ValidatedInput;
